// 🔧 logout.js
// ✅ Purpose: Sign out the current user and clear all related session data

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import FullPageSpinner from "../../components/FullPageSpinner";
import { logger } from '../../utils/logger';
import {
  SESSION_KEYS,
  clearPendingVoteNavigation,
  removeSessionValue,
} from "../../utils/browser_storage_helpers";

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    const doLogout = async () => {
      try {
        // 🔒 Sign out from Firebase
        await signOut(auth);
        clearPendingVoteNavigation();

        // 🧼 Clear Let's Go Vote session state
        removeSessionValue(
          SESSION_KEYS.PENDING_MANAGER_ACCEPT
        );

        removeSessionValue(
          SESSION_KEYS.LOGIN_WARNING
        );

        removeSessionValue(
          SESSION_KEYS.MANAGER_ACCEPTED_EVENT_NAME
        );

        // Legacy cleanup (safe to remove later)
        sessionStorage.removeItem("pendingGoogleLink");
        sessionStorage.removeItem("pendingFacebookLink");
        sessionStorage.removeItem("pendingGoogleEmail");
        sessionStorage.removeItem("pendingFacebookEmail");

        // ✅ Redirect to login
        navigate("/login?logout", { replace: true });
      } catch (error) {
        logger.error("❌ Logout failed:", {
          value: error
        });
      }
    };

    doLogout();
  }, [navigate]);

  return <FullPageSpinner message="Logging out..." />;

}
 
export default Logout;